import { NgModule, ErrorHandler, ModuleWithProviders } from '@angular/core';
import { appSettings } from '@nha/config';
import { LoggerApiConfiguration } from './logger-api-configuration.class';
import { ClientExceptionService } from './services/client-exception.service';
import { GlobalErrorHandler } from './services/global-error-handler.service';

@NgModule()
export class LoggerApiModule {
	static forRoot(): ModuleWithProviders<LoggerApiModule> {
		return {
			ngModule: LoggerApiModule,
			providers: [LoggerApiConfiguration, ClientExceptionService, { provide: ErrorHandler, useClass: GlobalErrorHandler }]
		};
	}
}

const consoleEnabled: boolean = appSettings.logger.consoleEnabled;

const consoleLog = console.log;
const consoleWarn = console.warn;
const consoleError = console.error;

const log = consoleEnabled ? consoleLog : () => {};
const warn = consoleEnabled ? consoleWarn : () => {};
const error = consoleEnabled ? consoleError : () => {};

console.log = log;
console.warn = warn;
console.error = error;
